import { TableContainer } from 'components/Table';
import styled from 'styled-components';

export const OtherSettingsTableContainer = styled(TableContainer)`
  gap: 1.5rem;
`;
